import React from "react";
import { AppBar, Typography, Box, Toolbar as MUIToolbar } from "@mui/material";
import { MainstayIcon } from "./MainstayIcon";

export function Toolbar() {
  return (
    <AppBar
      position="static"
      sx={{
        bgcolor: "#092E63;",
        height: "4rem",
      }}
    >
      <MUIToolbar
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-end",
          height: "100%",
          paddingBottom: "0.75rem",
        }}
      >
        <Box
          sx={{
            display: "flex",
            height: "1.5rem",
            justifyContent: "flex-end",
          }}
        >
          <Box
            sx={{
              marginRight: "0.375rem",
            }}
          >
            <MainstayIcon width="1.5rem" height="1.5rem" />
          </Box>
          <Typography
            variant="h6"
            sx={{
              alignSelf: "flex-end",
              fontWeight: "700",
              lineHeight: "1rem",
            }}
          >
            mainstay
          </Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            alignItems: "flex-end",
            height: "100%",
          }}
        >
          <Typography
            sx={{
              alignSelf: "flex-end",
              lineHeight: "0.8rem",
              fontWeight: "600",
              fontSize: "0.8rem",
            }}
          >
            Scholarship Search
          </Typography>
        </Box>
      </MUIToolbar>
    </AppBar>
  );
}
